var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import React from 'react';
import { useTheme } from '../utils';
import '@itwin/itwinui-css/css/tabs.css';
/**
 * Individual tab component to be used in the `labels` prop of `Tabs`.
 * @example
 * const tabs = [
 *   <Tab label='Label 1' sublabel='Description 1' />,
 *   <Tab label='Label 2' startIcon={<SvgPlaceholder />} />,
 * ];
 */
export var Tab = function (props) {
    var label = props.label, sublabel = props.sublabel, startIcon = props.startIcon, children = props.children, className = props.className, rest = __rest(props, ["label", "sublabel", "startIcon", "children", "className"]);
    useTheme();
    return (React.createElement("button", __assign({ className: cx('iui-tab', className), role: 'tab', tabIndex: -1 }, rest),
        startIcon &&
            React.cloneElement(startIcon, {
                className: 'iui-tab-icon',
                'aria-hidden': true,
            }),
        label && (React.createElement("span", { className: 'iui-tab-label' },
            React.createElement("div", null, label),
            sublabel && React.createElement("div", { className: 'iui-tab-description' }, sublabel))),
        children));
};
/**
 * @deprecated Use `Tab` instead.
 */
export var HorizontalTab = Tab;
